import { grey } from "@mui/material/colors";

const styles = {
  wrapper: { height: "1000px", overflow: "scroll", background: grey[100] },
  root: { my: 3, border: `1px solid ${grey[200]}` },
};

export default styles;
